export enum CsasDtoDocumentSignFieldState {
  SignatureStart = 'SignatureStart',
  SignatureDisabled = 'SignatureDisabled',
  Signing = 'Signing',
  ProcessingSignature = 'ProcessingSignature',
  Signed = 'Signed',
}

export enum CsasDtoDocumentFormFieldState {
  FieldStart = 'FieldStart',
  FieldInitialValue = 'FieldInitialValue',
  FieldValueChanged = 'FieldValueChanged',
  FieldDisabled = 'FieldDisabled',
}
